import { BaseCachedEntityStore } from './core/base.cached.entity.store';
import { KvAgtMsLiteModel } from 'app/models/kv.agt.ms.lite.model';

export class KvAgtWkzgKofferFzwStore extends BaseCachedEntityStore<KvAgtMsLiteModel> {
	idProp: string = 'id';
	apiPath = 'api/kv_agentur_ms/wkzgkofferfzw';

	createInstances(opts: any): KvAgtMsLiteModel {
		return new KvAgtMsLiteModel(opts);
	}
}
